import View from 'views/base/view';
import $ from 'jquery';
import yaml from 'js-yaml';
import EF from 'ef/ef';
import ForgeMenuItemTemplate from 'views/forge-editor/templates/forge-menu-item';
import Chaplin from 'chaplin';
import IconLoadService from 'services/loader-handler-services/icon-load-service';

const ForgeMenuItemView = View.extend({
  template: ForgeMenuItemTemplate,
  autoRender: true,
  autoAttach: true,
  model: new Chaplin.Model({}),
  initialize: function (model) {
    this.randomId = Math.trunc(Math.random() * 10000);
    this.menuItemId = `menuItem-${this.randomId}`;
    this.atomsShowing = false;
    this.atomsLoaded = false;
    this.usingBrowserEditor = model.usingBrowserEditor;
    this.level = model.level;
    this.zIndex = model.zIndex;
    this.contextmenuEvt = model.evt;
    this.forgeEditor = model.forgeEditor;
    this.atomModel = model.atomModel;
    this.blockType = model.blockType;
    this.appendToId = model.appendToId;
    this.atomArr = model.atomArr;
    this.model.set('randomId', this.randomId);
    this.model.set('menuItemId', this.menuItemId);
    this.model.set('blockType', this.blockType);
    View.prototype.initialize.apply(this, arguments);
    this.setListeners();
    setTimeout(() => {
      this.setMenuItem(this.contextmenuEvt, model.appendToId);
      this.addIcons();
    }, 0);
  },
  addIcons: function () {
    if (this.atomArr?.length > 0) {
      IconLoadService.applyIcon('far fa-arrow-right', `menuItemArrowIcon-${this.randomId}`, 'fa-lg');
    }
  },
  // We're using pub / sub to constantly keep all menu items coordinated
  setListeners: function () {
    this.subscribeEvent('forge:menu:exit', evt => {
      this.dispose();
    });
    // Hide my subviewHolder
    this.subscribeEvent('forge:menu:hideSubview', subviewHolderId => {
      if (`${this.menuItemId}-subviewHolder` === subviewHolderId) {
        this.hideSubview();
      }
    });
    this.subscribeEvent('forge:menu:item:mouseenter', evt => {
      // If my level is 2 away from the mouseover'd level, tell my parent to hide me
      if (this.level - evt.level > 1) {
        this.publishEvent('forge:menu:hideSubview', this.appendToId);
      }
      // color the arrow
      if (this.atomsShowing && evt.level !== this.level) {
        this.$el.find('.menuItemArrow').css('color', '#007bff');
      } else {
        this.$el.find('.menuItemArrow').css('color', '#000000');
      }
      if (
        this.atomsShowing &&
        evt.menuItemId !== this.menuItemId &&
        evt.appendToId !== `${this.menuItemId}-subviewHolder` &&
        (evt.level - 1 === this.level || evt.level === this.level)
      ) {
        this.hideSubview();
      }
    });
  },
  showSubview: function (evt) {
    let model;
    if (!this.atomsLoaded) {
      for (let i = 0; i < this.atomArr.length; i++) {
        model = {
          evt: this.contextmenuEvt,
          blockType: `${this.atomArr[i].atomType}`,
          appendToId: `${this.menuItemId}-subviewHolder`,
          atomArr: this.atomArr[i].atomArr,
          atom: this.atomArr[i],
          level: this.level + 1,
          zIndex: this.zIndex + 1,
          forgeEditor: this.forgeEditor,
          usingBrowserEditor: this.usingBrowserEditor,
          atomModel: this.atomArr[i],
        };
      }
      $(`#${this.menuItemId}-subviewHolder`).css('z-index', model.zIndex);
      this.atomsLoaded = true;
    }
    $(`#${this.menuItemId}-subviewHolder`).show();
    this.atomsShowing = true;
  },
  hideSubview: function () {
    $(`#${this.menuItemId}-subviewHolder`).hide();
    this.atomsShowing = false;
  },
  setMenuItem: function (evt, appendToId) {
    $(`#${appendToId}`).append(this.$el);

    $(`#${this.menuItemId}-item`).mouseenter(evt => {
      evt.stopPropagation();
      this.publishEvent(`forge:menu:item:mouseenter`, this);
      $(`#${this.menuItemId}-item`).addClass('active');
      if (this.atomArr?.length > 0 && !this.atomsShowing) {
        this.showSubview(evt);
      }
    });
    $(`#${this.menuItemId}-item`).mouseleave(evt => {
      // Don't use stopPropagation here. We need $floater to hear the mouseleave
      if (!$(`#${this.menuItemId}-item`).hasClass('clickedElem')) {
        $(`#${this.menuItemId}-item`).removeClass('active');
      }
    });
    $(`#${this.menuItemId}-item`).click(evt => {
      evt.stopPropagation();
      let blockModel = null,
        atomModel = null;
      if (this.usingBrowserEditor) {
        const obj = { blocks: [this.contextmenuEvt.modelObj] };
        blockModel = yaml.dump(obj, {
          skipInvalid: true,
          lineWidth: -1,
          noRefs: true,
        });
        if (this.atomModel) {
          atomModel = yaml.dump(this.atomModel, {
            skipInvalid: true,
            lineWidth: -1,
            noRefs: true,
          });
        }
      }

      const xpath = this.getXPathTo(this.contextmenuEvt.$el[0]);
      const $curElem = this.contextmenuEvt.$el;
      const el = this.getElementByXPath(xpath);
      let key;
      if (EF.module) {
        key = EF.module.currentActivity.currentPage.attributes.key;
      }
      const msg = {
        event_type: 'forge_mode',
        detail: {
          action: 'editblock',
          forgepath:
            el.getAttribute('data-forge-path') ||
            $(el).parents('[data-forge-path]:not([data-forge-path="undefined"])').data('data-forge-path'),
          xpath: xpath,
          model: blockModel, // only used by browserCourseEditor
          atomModel: atomModel, // only used by browserCourseEditor
          key,
          contentRegion:
            el.getAttribute('data-content-region') ||
            $(el).parents('[data-content-region]:not([data-content-region="undefined"])').data('content-region'),
        },
        sender: 'sdkForge',
      };
      window.parent?.postMessage(msg, '*');

      $('.clickedElem').removeClass('active');
      $('.clickedElem').removeClass('clickedElem');
      $(`#${this.menuItemId}-item`).addClass('clickedElem');
      $(`#${this.menuItemId}-item`).addClass('active');
      this.forgeEditor.setCurElem($curElem);
    });
  },
  getElementByXPath: function (path) {
    return new XPathEvaluator().evaluate(
      path,
      document.documentElement,
      null,
      XPathResult.FIRST_ORDERED_NODE_TYPE,
      null
    ).singleNodeValue;
  },
  getXPathTo: function (element) {
    if (element.id !== '') {
      return `id("${element.id}")`;
    }
    if (element === document.body) {
      return element.tagName;
    }
    let ix = 0;
    const siblings = element.parentNode.childNodes;
    for (let i = 0; i < siblings.length; i++) {
      const sibling = siblings[i];
      if (sibling === element) {
        return `${this.getXPathTo(element.parentNode)}/${element.tagName}[${ix + 1}]`;
      }
      if (sibling.nodeType === 1 && sibling.tagName === element.tagName) {
        ix++;
      }
    }
  },
  dispose: function () {
    $(`#${this.menuItemId}-subviewHolder`).empty();
    this.unsubscribeAllEvents();
    this.atomsShowing = false;
    this.atomsLoaded = false;
  },
});
export default ForgeMenuItemView;
